export const DEFAULT_LANGUAGE = "ro";
export const FALLBACK_LANGUAGE = DEFAULT_LANGUAGE;
